import { useAuth0 } from '@auth0/auth0-react';
import {
    Box,
    Grid,
    styled,
    Typography,
    Paper,
    Avatar,
    Button,
    Chip,
    CircularProgress,
    Card,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { intervalToDuration, parse } from 'date-fns';
import { useSelector } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import ApplyForJob from './ApplyForJob';
import axios from 'axios';
import TeacherSubmissions from './TeacherSubmissions';
import { Route, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import ViewSchoolJobApplication from '../../views/ViewSchoolJobApplication';

const BookingButton = styled(Button)(({ theme }) => ({
    padding: '10px 0px',
    margin: '10px auto',
    width: '100%',
    maxWidth: '150px',
    borderRadius: '30px',
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: '1rem',
    margin: '2rem',
    '&:hover, &:focus': {
        boxShadow:
            '0px 7px 8px -4px rgba(0,0,0,0.2), 0px 12px 17px 2px rgba(0,0,0,0.14), 0px 5px 22px 4px rgba(0,0,0,0.12)',
    },
    [theme.breakpoints.down('sm')]: {
        margin: '2rem .3rem',
    },
    [theme.breakpoints.up('sm')]: {
        maxWidth: '45rem',
        margin: '2rem auto',
    },
}));

const ViewJob = props => {
    // let history = useHistory();
    let { teacherId } = useParams();
    const { user, isAuthenticated, loginWithRedirect, getAccessTokenSilently } =
        useAuth0();

    const [displayJobSubmissionDetails, setDisplayJobSubmissionDetails] =
        useState(false);

    const [jobSubmissions, setJobSubmissions] = useState({
        Data: [],
        Count: 0,
    });
    const [loadingSubmissions, setLoadingSubmissions] = useState(true);
    const [currentUserHasApplied, setCurrentUserHasApplied] = useState(0);
    const [selectedJob, setSelectedJob] = useState({});

    const profile = useSelector(state => state.profile.profile);
    const profileStatus = useSelector(state => state.profile.status);

    const calculateDisplay = (startTime, endTime) => {
        const duration = intervalToDuration({
            start: startTime,
            end: endTime,
        });
        if (duration.months > 0) {
            return `${duration.months} month${duration.months > 1 ? 's' : ''}`;
        }
        if (duration.weeks > 0) {
            return `${duration.weeks} week${duration.weeks > 1 ? 's' : ''}`;
        }
        if (duration.days > 0) {
            return `${duration.days} day${duration.hours > 1 ? 's' : ''}`;
        }
        if (duration.days === 0) {
            return `${duration.hours} hour${
                duration.hours === 0 || duration.hours > 1 ? 's' : ''
            }`;
        }
    };

    const applied = () => {
        setCurrentUserHasApplied(2);
    };

    const login = async () => {
        await loginWithRedirect({
            scope: `${process.env.REACT_APP_scope} teacherProfile`,
            display: 'popup',
            screen_hint: 'signup',
            redirectUri: `${process.env.REACT_APP_hostUrl}`,
            appState: {
                'type': 'teacher',
                'returnTo': '/home?type=teacher',
            },
        });
    };
    useEffect(() => {
        if (isAuthenticated && profileStatus === 'succeeded') {
            try {
                setLoadingSubmissions(true);
                async function fetchSubmissions() {
                    const token = await getAccessTokenSilently();
                    const getJobSubmission = await axios.get(
                        `${process.env.REACT_APP_API_GATEWAY}/jobSubmissions?jobId=${props.job.pk1}${props.job.sk1}`,
                        {
                            timeout: 30000,
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`,
                            },
                        }
                    );
                    setJobSubmissions(getJobSubmission.data.Message);
                    setCurrentUserHasApplied(
                        getJobSubmission.data.Message.Data.filter(
                            sub =>
                                `${sub['gs1-pk']}` ===
                                `${props.job.pk1}${props.job.sk1}`
                        ).length === 0
                            ? 1
                            : 2
                    );
                }
                fetchSubmissions();
            } catch (err) {
                console.log(err);
            } finally {
                setLoadingSubmissions(false);
            }
        }
        console.log('profile', profile);
    }, [profileStatus]);

    const updateSubmissionStatus = (status, teacherId, jobId) => {
        console.log(status, teacherId, jobId);
        setJobSubmissions({
            ...jobSubmissions,
            Data: jobSubmissions.Data.map(submission => {
                if (
                    submission.user.uniqueId === teacherId &&
                    submission.submission['gs1-pk'] === jobId
                ) {
                    submission.submission.status = status;
                }
                return submission;
            }),
        });
    };
    const updateJobStatus = async (pk1, sk1, gs1pk) => {
        console.log(pk1, sk1);
        const data = {
            'pk1': pk1,
            'sk1': sk1,
            'gs1pk': gs1pk,
        };
        console.log(pk1, sk1, data);

        const token = await getAccessTokenSilently();
        const createJob = await axios.post('/updateJob', data, {
            baseURL: process.env.REACT_APP_API_GATEWAY,
            timeout: 30000,
            headers: {
                authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        if (createJob.data.Message.Success === true) {
            console.log('success');
            props.updateJobStatus(pk1, sk1, gs1pk);
        }
    };
    return (
        <>
            <Route path={['/jobs', '/schoolJobs']} exact>
                <StyledPaper elevation={3}>
                    <Grid container>
                        <Grid
                            item
                            xs={2}
                            sm={1}
                            sx={{
                                alignItems: 'center',
                                margin: '0 auto',
                            }}
                        >
                            <Avatar
                                sx={{
                                    width: '50px',
                                    height: '50px',
                                    boxShadow:
                                        '0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)',
                                }}
                                src={props.job.schoolLogo}
                            ></Avatar>
                        </Grid>
                        <Grid
                            item
                            xs={8}
                            sm={10}
                            sx={{
                                textAlign: 'left',
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    marginLeft: '1rem',
                                }}
                            >
                                {props.job.jobTitle}
                            </Typography>

                            <Typography
                                variant="subtitle2"
                                sx={{
                                    marginLeft: '1rem',
                                }}
                            >
                                {props.job.schoolName} - {props.job.typeOfJob}
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{
                                    margin: '4px 0rem 0rem 1rem',
                                }}
                            >
                                {`Posted: ${calculateDisplay(
                                    props.job.postDate,
                                    new Date(Date.now())
                                )} ago`}
                                {props.job.status === 'closed' ? (
                                    <Chip
                                        sx={{
                                            borderRadius: '4px',
                                            marginLeft: '12px',
                                        }}
                                        label={`Status: ${props.job.status}`}
                                    />
                                ) : (
                                    <>
                                        {props.job.expiryDate !== undefined && (
                                            <Chip
                                                sx={{
                                                    borderRadius: '4px',
                                                    marginLeft: '12px',
                                                }}
                                                label={`Expires in ${calculateDisplay(
                                                    new Date(Date.now()),
                                                    parse(
                                                        props.job.expiryDate,
                                                        'yyyy-MM-dd',
                                                        new Date()
                                                    )
                                                )}`}
                                            />
                                        )}
                                    </>
                                )}
                            </Typography>

                            <Typography
                                variant="h6"
                                sx={{
                                    margin: '24px 0rem 0rem 1rem',
                                }}
                            >
                                School Brief
                            </Typography>
                            <Typography
                                sx={{
                                    margin: '4px 0rem 0rem 1rem',
                                }}
                            >
                                {props.job.schoolSummary}
                            </Typography>
                            <Typography
                                variant="h6"
                                sx={{
                                    margin: '24px 0rem 0rem 1rem',
                                }}
                            >
                                Job Description
                            </Typography>
                            <Typography
                                sx={{
                                    margin: '4px 0rem 0rem 1rem',
                                }}
                            >
                                {props.job.jobSummary}
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{
                                    margin: '24px 0rem 0rem 1rem',
                                }}
                            >
                                {props.job.location.split(',')[1]}
                            </Typography>
                            <Box
                                sx={{
                                    margin: '24px 0px 0px 1rem',
                                }}
                            >
                                {displayJobSubmissionDetails ? (
                                    <ApplyForJob
                                        closeApply={() => {
                                            if (isAuthenticated) {
                                                setDisplayJobSubmissionDetails(
                                                    false
                                                );
                                            }
                                        }}
                                        jobId={`${props.job.pk1}${props.job.sk1}`}
                                        jobTitle={props.job.jobTitle}
                                        applied={applied}
                                    />
                                ) : (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginTop: '24px',
                                        }}
                                    ></Box>
                                )}
                            </Box>
                        </Grid>
                        <Grid
                            xs={2}
                            sm={1}
                            item
                            sx={{
                                textAlign: 'right',
                            }}
                        >
                            <CloseIcon
                                onClick={props.close}
                                color="primary"
                                fontSize="large"
                                sx={{
                                    border: '1px solid #1E7CA8',
                                    borderRadius: '50%',
                                    padding: '4px',
                                    cursor: 'pointer',
                                }}
                            />
                        </Grid>
                    </Grid>
                    {/* put it here */}
                    <Grid
                        container
                        sx={{
                            margin: '12px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        {isAuthenticated &&
                            profile.Data.Items[0].type === 'School' && (
                                <>
                                    {props.job.status !== 'closed' && (
                                        <BookingButton
                                            onClick={() =>
                                                updateJobStatus(
                                                    props.job.pk1,
                                                    props.job.sk1,
                                                    props.job['gs1-pk']
                                                )
                                            }
                                        >
                                            Mark as Filled
                                        </BookingButton>
                                    )}
                                </>
                            )}
                        {isAuthenticated ? (
                            <>
                                {profile.Data.Items[0].type === 'Teacher' ? (
                                    <>
                                        {displayJobSubmissionDetails ===
                                            false && (
                                            <>
                                                {props.job.status ===
                                                'closed' ? (
                                                    <Typography>
                                                        Position Filled
                                                    </Typography>
                                                ) : (
                                                    <>
                                                        {currentUserHasApplied ===
                                                        1 ? (
                                                            <BookingButton
                                                                onClick={() => {
                                                                    if (
                                                                        isAuthenticated
                                                                    ) {
                                                                        setDisplayJobSubmissionDetails(
                                                                            true
                                                                        );
                                                                    }
                                                                }}
                                                            >
                                                                Apply Now
                                                            </BookingButton>
                                                        ) : (
                                                            <>
                                                                {currentUserHasApplied ===
                                                                2 ? (
                                                                    <Typography>
                                                                        You've
                                                                        already
                                                                        applied
                                                                        for this
                                                                        job
                                                                    </Typography>
                                                                ) : (
                                                                    <>
                                                                        {props
                                                                            .job
                                                                            .expiryDate <
                                                                        Date.now() ? (
                                                                            <Typography>
                                                                                Job
                                                                                has
                                                                                expired
                                                                            </Typography>
                                                                        ) : (
                                                                            <CircularProgress />
                                                                        )}
                                                                    </>
                                                                )}
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        {loadingSubmissions ? (
                                            <CircularProgress />
                                        ) : (
                                            <>
                                                {jobSubmissions.Count > 0 && (
                                                    <>
                                                        <Grid item xs={12}>
                                                            <Typography variant="h2">
                                                                Applications
                                                            </Typography>
                                                        </Grid>
                                                        {jobSubmissions.Data.map(
                                                            (
                                                                submission,
                                                                index
                                                            ) => {
                                                                return (
                                                                    <TeacherSubmissions
                                                                        submission={
                                                                            submission
                                                                        }
                                                                        key={
                                                                            index
                                                                        }
                                                                    />
                                                                );
                                                            }
                                                        )}
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </>
                                )}
                            </>
                        ) : (
                            <Box flexDirection="row">
                                <Typography>Log in to apply now</Typography>
                                <BookingButton onClick={login}>
                                    Login
                                </BookingButton>
                            </Box>
                        )}
                    </Grid>
                </StyledPaper>
            </Route>
            <Route path="/schooljobs/:jobId/:teacherId">
                <ViewSchoolJobApplication
                    jobSubmissions={jobSubmissions}
                    updateSubmissionStatus={updateSubmissionStatus}
                />
            </Route>
        </>
    );
};

//This page is the location users are routed too when they log in
//It will detect if the user has a profile or not
//with no profile the user will be navigated to setUpProfile
//With a completed profile the user will be navigated to the Dashboard
export default ViewJob;
